import { Pipe, PipeTransform } from '@angular/core';
import { EnumIdsTcEstadoSolicitudCam } from '../../../../_campanias/types/enum';

@Pipe({ name: 'IconoEstadoSolicitudCam' })
export class IconoEstadoSolicitudCamPipe implements PipeTransform {
    private allowedEstados = [
        EnumIdsTcEstadoSolicitudCam.ID_BORRADOR,
        EnumIdsTcEstadoSolicitudCam.ID_PENDIENTE,
        EnumIdsTcEstadoSolicitudCam.ID_VALIDADA,
        EnumIdsTcEstadoSolicitudCam.ID_DEVUELTA,
        EnumIdsTcEstadoSolicitudCam.ID_ACEPTADA,
        EnumIdsTcEstadoSolicitudCam.ID_RECHAZADA,
        EnumIdsTcEstadoSolicitudCam.ID_ANULADA,
    ];
    transform(value: number): string {
        if (value && this.allowedEstados.indexOf(value) !== -1) {
            return './assets/images/EstadoSolicitud/EstadoSolicitudCam/' + value + '.png';
        }
        return './assets/images/EstadoSolicitud/EstadoSolicitudCam/0.png';
    }
}
